import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ba11608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "is-nav" }
const _hoisted_2 = { class: "home_contents_wrapper" }
const _hoisted_3 = { class: "search_condition" }
const _hoisted_4 = { class: "search_condition_layout_detail" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search_condition_detail_title" }, "キーワード", -1))
const _hoisted_6 = { class: "search_condition_detail_value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search_condition_detail_title" }, "求人ID", -1))
const _hoisted_8 = { class: "search_condition_detail_value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search_condition_detail_title" }, "業種", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search_condition_detail_title" }, "職種", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search_condition_detail_title" }, "勤務地", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search_condition_detail_title" }, "雇用形態", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search_condition_detail_title" }, "年収", -1))
const _hoisted_14 = { class: "search_condition_detail_value" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search_condition_detail_title" }, "時給", -1))
const _hoisted_16 = { class: "search_condition_detail_value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "search_condition_detail_title" }, "こだわり", -1))
const _hoisted_18 = { class: "search_condition_layout_button" }
const _hoisted_19 = { class: "home_title" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "home_title_text" }, "検索結果", -1))
const _hoisted_21 = { class: "home_title_count" }
const _hoisted_22 = { class: "home_layout_recommend_operation" }
const _hoisted_23 = { class: "recommend_operation_inner_box" }
const _hoisted_24 = { class: "recommend_operation_inner_box_sort" }
const _hoisted_25 = { class: "recommend_operation_inner_box_filter" }
const _hoisted_26 = { class: "recommend_operation_inner_box" }
const _hoisted_27 = { class: "recommend_operation_inner_box_allcheck" }
const _hoisted_28 = {
  class: "checkbox",
  for: "allcheck_1"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox_text" }, "すべてをチェック", -1))
const _hoisted_30 = { class: "recommend_operation_inner_box_bulk" }
const _hoisted_31 = { class: "home_layout_card" }
const _hoisted_32 = {
  key: 0,
  class: "search_layout_result_empty"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search_result_empty_text" }, "条件に一致する求人はありません", -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "home_layout_readmore"
}

import { useRoute, useRouter } from 'vue-router';
import { ref, computed, onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import BaseSelectBox from '@/components/BaseSelectBox.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseThreeButtonModal from '@/components/BaseThreeButtonModal.vue';
import SearchOrderCard from '@/components/OrderCard.vue';
import Loading from '@/components/Loading.vue';
import { OrderCard } from '@/types';

type GlobalError = {
  code: string;
  args: string[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ListView',
  setup(__props) {

const sortOption = [
{
    value: 4,
    label: 'おすすめ順',
  },
  {
    value: 1,
    label: '未読順',
  },
  {
    value: 2,
    label: '新着順',
  },
  {
    value: 3,
    label: '人気順',
  },
];
const filterOption = [
  {
    value: 0,
    label: 'すべての求人',
  },
  {
    value: 1,
    label: '未読',
  },
  {
    value: 2,
    label: '面接確約',
  },
  {
    value: 4,
    label: '書類通過率70％以上',
  },
  {
    value: 3,
    label: 'CAイチオシ',
  },
  {
    value: 5,
    label: 'AIマッチ',
  },
];
const route = useRoute();
const router = useRouter();

const more = ref(!!route.hash);

const store = useStore();

const isLoading = ref(false);
const showModal = ref(false);
const hasSearchOrderConditions = ref(false);

const resSearchOrderState = computed(() => {
  return store.getters['searchOrder/resSearchOrder'];
});
const searchOrderConditions = computed(() => {
  return store.getters['searchOrder/searchOrderConditions'];
});
const jobCards = computed(() => {
  return store.getters['searchOrder/orders'];
});
const searchableOrder = computed(() => {
  return store.getters['userMenu/searchableOrder'];
});
const isSearchLockUser = computed(() => {
  return store.getters['userMenu/isSearchLockUser'];
});

const allchecked = computed({
  get: () => store.getters['searchOrder/allChecked'] as boolean,
  set: (value) => store.commit('searchOrder/changeAllChecked', value),
});
const hasNextPage = computed(() => {
  return store.getters['searchOrder/hasNextPage'] as boolean;
});
const seeMore = async () => {
  isLoading.value = true;
  await store.dispatch('searchOrder/moreSee');
  router.replace({ hash: '#more' });
  isLoading.value = false;
};

const toggleConsider = async (orderId: number) => {
  await store.dispatch('searchOrder/toggleConsider', { orderId });
};

const apiErrorMessages = ref<string[]>([]);
const apply = async (orderId: number) => {
  isLoading.value = true;
  try {
    await store.dispatch('searchOrder/applyOrder', { orderId });
    store.dispatch('toasts/appendTimeToast', { label: '応募を完了しました' });
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 400) {
      error.response.data.errorDetail.globalError.map((e: GlobalError) => {
        return e.args.map((arg) => {
          apiErrorMessages.value.push(arg);
        });
      });
    }
    apiErrorMessages.value.forEach((message) => {
      store.dispatch('toasts/appendTimeToast', { label: message, duration: null });
    });
  } finally {
    isLoading.value = false;
  }
};
const change = (order: OrderCard) => {
  store.commit('searchOrder/setChecked', { orderId: order.orderId, checked: order.checked });
};
const sort = computed({
  get: () => store.getters['searchOrder/sortKeyId'] as number,
  set: (value) => store.dispatch('searchOrder/changeSortKey', { key: value }),
});
const filter = computed({
  get: () => store.getters['searchOrder/filterId'] as number,
  set: (value) => store.dispatch('searchOrder/changeFilter', { filterId: value }),
});
const navigateDetail = () => {
  resetSearchConditionFlg.value = false;
};

//一括操作 モーダル内ボタン
const addConsiderAll = async () => {
  isLoading.value = true;
  await store.dispatch('searchOrder/addConsider');
  store.commit('searchOrder/changeAllChecked', false);
  isLoading.value = false;
  showModal.value = false;
  store.dispatch('toasts/appendTimeToast', { label: 'チェックした求人を検討中に追加しました' });
};

onBeforeMount(async () => {
  await store.dispatch('userMenu/receive');
  if (!more.value) {
    init();
  }
});
// 検索結果取得(初期表示)
const init = async () => {
  isLoading.value = true;
  // 求人検索不可 or 求人検索ロックユーザーはリダイレクト
  if (!searchableOrder.value || isSearchLockUser.value) {
    router.replace({ name: 'h00' });
  }
  try {
    await store.dispatch('searchOrder/receiveSearchOrder');
    // 検索条件
    Object.keys(searchOrderConditions.value).forEach((key) => {
      if (key === 'indsctgList' || key === 'ocupList') {
        return;
      }
      if (searchOrderConditions.value[key]) {
        hasSearchOrderConditions.value = true;
      }
    });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const resetSearchConditionFlg = ref(true);
const prevSearchPage = () => {
  resetSearchConditionFlg.value = false;
  router.push({ name: 'h00' });
};

onBeforeUnmount(async () => {
  // 検索条件を破棄する
  if (resetSearchConditionFlg.value) {
    store.commit('searchOrder/initIdsForApi');
    store.commit('searchOrder/initSendSearchOrder');
    store.commit('searchOrder/initSearchOrderConditions');
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(hasSearchOrderConditions.value ? null : '検索条件なし') + " ", 1),
          (_unref(searchOrderConditions).keyword)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(searchOrderConditions).keyword), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_unref(searchOrderConditions).orderId)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(searchOrderConditions).orderId), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_unref(searchOrderConditions).indsctgIdToTextList)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchOrderConditions).indsctgIdToTextList, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item,
                    class: "search_condition_detail_value"
                  }, _toDisplayString(item), 1))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          (_unref(searchOrderConditions).ocupToTextList)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchOrderConditions).ocupToTextList, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item,
                    class: "search_condition_detail_value"
                  }, _toDisplayString(item), 1))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          (_unref(searchOrderConditions).workAreaTextList)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _hoisted_11,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchOrderConditions).workAreaTextList, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item,
                    class: "search_condition_detail_value"
                  }, _toDisplayString(item), 1))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          (_unref(searchOrderConditions).empTypeTextList)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchOrderConditions).empTypeTextList, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item,
                    class: "search_condition_detail_value"
                  }, _toDisplayString(item), 1))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          (_unref(searchOrderConditions).salaryType === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, [
                  (_unref(searchOrderConditions).salaryMin)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(searchOrderConditions).salaryMin) + "万円〜", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(searchOrderConditions).salaryMax)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(searchOrderConditions).salaryMax) + "万円", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_unref(searchOrderConditions).salaryType === 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, [
                  (_unref(searchOrderConditions).salaryMin)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(searchOrderConditions).salaryMin) + "円〜", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_unref(searchOrderConditions).salaryMax)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(searchOrderConditions).salaryMax) + "円", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_unref(searchOrderConditions).recommendedPointTextList)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                _hoisted_17,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchOrderConditions).recommendedPointTextList, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item,
                    class: "search_condition_detail_value"
                  }, _toDisplayString(item), 1))
                }), 128))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(BaseButton, {
            onClick: prevSearchPage,
            theme: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("条件を変更")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(resSearchOrderState).dataRecordCountAll) + "件", 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(BaseSelectBox, {
                options: sortOption,
                modelValue: _unref(sort),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sort) ? (sort).value = $event : null)),
                modelModifiers: { number: true },
                placeholder: "新着順"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(BaseSelectBox, {
                options: filterOption,
                modelValue: _unref(filter),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filter) ? (filter).value = $event : null)),
                modelModifiers: { number: true },
                placeholder: "条件で絞り込み"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, [
                _withDirectives(_createElementVNode("input", {
                  class: "checkbox_input",
                  id: "allcheck_1",
                  type: "checkbox",
                  name: "allcheck",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(allchecked) ? (allchecked).value = $event : null))
                }, null, 512), [
                  [_vModelCheckbox, _unref(allchecked)]
                ]),
                _hoisted_29
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = () => (showModal.value = true)),
                class: "button_bulk_operation"
              }, "一括操作")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jobCards), (card) => {
            return (_openBlock(), _createBlock(SearchOrderCard, {
              key: card.orderId,
              order: card,
              onChange: change,
              onApply: apply,
              onToggleConsider: toggleConsider,
              onNavigateDetail: navigateDetail
            }, null, 8, ["order"]))
          }), 128))
        ])
      ]),
      (_unref(resSearchOrderState).dataRecordCountAll < 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
        : _createCommentVNode("", true),
      (_unref(resSearchOrderState).dataRecordCountAll > 0 && _unref(hasNextPage))
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("button", {
              onClick: seeMore,
              class: "button_read_more"
            }, "もっと見る")
          ]))
        : _createCommentVNode("", true)
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(BaseThreeButtonModal, {
          key: 0,
          "right-btn-text": "検討中に入れる",
          "left-btn-text": "キャンセル",
          onRightBtnClick: addConsiderAll,
          onLeftBtnClick: _cache[4] || (_cache[4] = () => (showModal.value = false))
        }, {
          large: _withCtx(() => [
            _createTextVNode("チェックした求人を検討中に入れますか？")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})